import { InvoiceIconWithGrayBg, NavCloseIcon } from 'assets/icons';
import { GenericModal } from 'components';
import { FC } from 'react';
import { VoidFn } from 'types/baseTypes';

interface NoSelfCheckoutPopupProps {
  isEdit: boolean;
  onContinue: VoidFn;
  onEditPaymentMethods: VoidFn;
  onClose: VoidFn;
  isActionLoading: boolean;
}

const NoSelfCheckoutPopup: FC<NoSelfCheckoutPopupProps> = ({
  isEdit,
  onContinue,
  onEditPaymentMethods,
  onClose,
  isActionLoading
}) => {
  return (
    <GenericModal
      MainIcon={InvoiceIconWithGrayBg}
      showModal={true}
      title={`${isEdit ? 'Save' : 'Create'} invoice with no self-checkout methods ?`}
      titleStyle="text-center"
      subTitleStyle="text-center text-primaryText text-sbase font-normal"
      subTitle="Customer won't be able to pay online. You can always manually record payments by other methods."
      primaryBtnLabel="Yes, continue"
      primaryBtnId="continue-without-self-checkout"
      primaryBtnStyle="mt-2"
      onPrimaryBtnClick={onContinue}
      secondaryBtnId="edit-payment-methods"
      secondaryBtnStyle="border-borderGray"
      secondaryBtnLabel="Edit payment methods"
      onSecondaryBtnClick={onEditPaymentMethods}
      closeIconStyle="top-3 right-3"
      CloseIcon={NavCloseIcon}
      isActionInProgress={isActionLoading}
      onCloseIconClick={onClose}
      className="!px-5 !py-6"></GenericModal>
  );
};

export default NoSelfCheckoutPopup;
